<script>
	import { cuenta } from './../controlador/store.js';
    import {location, replace} from 'svelte-spa-router';
    import { beforeUpdate } from 'svelte';
    let abierto = false;
    let actual = '/home';
    beforeUpdate(()=>{
        if ($cuenta.user == undefined){
            replace('/');
        }
        if ($location != actual){
            abierto = false;
            actual = $location;
        }
    })
    function togle(){
        abierto = !abierto;
    }
</script>
{#if $location != '/' && $location != '/primera/vez' && $location.includes('/ver/receta/') == false}
    <div class="nav">
        <div on:click={togle} class="menuicon">
            <i class="ph-dots-three-outline-vertical"></i>
        </div>
        <div class="logo">
            <img src="/logo.svg" alt="">
        </div>
    </div>
{/if}
<div class={(abierto?'drawer abierto':'drawer')}>
    <ul>
        <li><a href="#/home"><i class="ph-house"></i>Inicio</a></li>
        <li><a href="#/cuenta"><i class="ph-identification-card"></i>Cuenta</a></li>
        <li><a href="#/historial"><i class="ph-folder-notch-open"></i>Historial</a></li>
    </ul>
</div>

<style>
    .drawer{
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        top: 0;
        left: -100vw;
        background: var(--azul);
        height: 100%;
        width: 100%;
        transition: all .3s ease;
        z-index: 300;
    }
    .abierto{
        left: 0;
    }
    ul{
        list-style: none;
        height: auto;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        margin: 0;
        padding: 0;
    }
    li{
        height: 100px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    li > a{
        height: 100px;
        width: 100%;
        padding: 10px;
        display: flex;
        align-items: center;
        text-decoration: none;
        color: white;
        font-size: 20px;
        border-bottom: solid 1px rgba(0,0,0,.1);
    }
    li:nth-child(1){
        border-top: solid 1px rgba(0,0,0,.1);
    }
    li > a > i {
        margin-top: 5px;
        margin-right: 5px;
        font-size: 40px;
    }
    .nav{
        position: relative;
        width: 100vw;
        max-width: 100%;
        height: 50px;
        background: var(--azul);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .menuicon{
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        left: 5px;
        top: 5px;
        width: 40px;
        height: 40px;
        font-size: 30px;
        color: white;
        z-index: 900;
    }
    img{
        height: 40px;
    }
</style>